import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { IconType } from 'react-icons';
import { motion } from 'framer-motion';

// --- KÉPEK IMPORTÁLÁSA ---
// @ts-ignore
import gyuruImg from '../videos/gyuru.PNG'; 
// @ts-ignore
import vacsoraImg from '../videos/vacsora.PNG';
// @ts-ignore
import pezsgoImg from '../videos/pezsgo.PNG';
// @ts-ignore
import templomImg from '../videos/templom.PNG';

const primaryColor = '#002D62'; 

const renderImage = (imgSrc: string, rotate: number = 0) => {
  return (
    <img 
      src={imgSrc} 
      alt="Program ikon" 
      style={{ 
        width: 28, 
        height: 28, 
        objectFit: 'contain',
        transform: `rotate(${rotate}deg)` 
      }} 
    />
  );
};

const events = [
  { time: '15:00', title: 'Templomi esküvő', sub: 'Bugyi', targetId: 'bugyi-helyszin', icon: renderImage(templomImg) },
  { time: '16:30', title: 'Vendégvárás', sub: 'Levendulás', targetId: 'levendulas-helyszin', icon: renderImage(pezsgoImg) },
  { time: '17:30', title: 'Polgári szertartás', targetId: 'levendulas-helyszin', icon: renderImage(gyuruImg, -45) }, 
  { time: '19:30', title: 'Vacsora', targetId: 'levendulas-helyszin', icon: renderImage(vacsoraImg) },
];

const Program: React.FC = () => {

  const scrollToLocation = (id?: string) => {
    if (!id) return;
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -50; 
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ py: { xs: 10, md: 10 }, overflowX: 'hidden' }}>
      <Container maxWidth="xl">
        
        {/* FŐCÍM */}
        <Box sx={{ textAlign: 'center', mb: 10 }}>
          <Typography 
            variant="h2" 
            sx={{ color: 'primary.main', fontSize: { xs: '3rem', md: '5rem' } }}
          >
            Napi Program
          </Typography>
        </Box>

        {/* IDŐVONAL */}
        <Box sx={{ position: 'relative', width: '100%', pt: 4, pb: 2 }}>
          
          {/* ASZTALI VÍZSZINTES VONAL */}
          <Box 
            sx={{ 
              display: { xs: 'none', md: 'block' },
              position: 'absolute', 
              top: '125px', 
              left: '12%', 
              right: '12%', 
              height: '1px', 
              bgcolor: 'primary.main', 
              zIndex: 0 
            }} 
          />

          {/* Flex konténer az elemekhez */}
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' }, 
              justifyContent: 'space-between',
              alignItems: { xs: 'center', md: 'flex-start' },
              gap: { xs: 6, md: 2 },
              position: 'relative',
              zIndex: 1
            }}
          >
            {events.map((event, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                style={{ 
                  position: 'relative', 
                  flex: 1, 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  width: '100%' 
                }}
              >
                
                {/* --- 1. MOBIL VONALDARAB: A kapszula és az Ikon között --- */}
                <Box 
                  sx={{ 
                    display: { xs: 'block', md: 'none' },
                    position: 'absolute', 
                    top: '20px', 
                    left: '50%', 
                    transform: 'translateX(-50%)',
                    width: '1px', 
                    height: '60px', 
                    bgcolor: 'primary.main', 
                    zIndex: 0 
                  }} 
                />

                {/* 1. Időpont (Kapszula) */}
                <Box 
                  sx={{ 
                    bgcolor: primaryColor, 
                    color: 'white', 
                    py: 1, 
                    px: 3, 
                    borderRadius: '20px', 
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    mb: 3,
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    position: 'relative',
                    zIndex: 2 
                  }}
                >
                  {event.time}
                </Box>

                {/* 2. Ikon */}
                <Box 
                  onClick={() => scrollToLocation(event.targetId)}
                  sx={{ 
                    width: 60, 
                    height: 60, 
                    borderRadius: '50%', 
                    bgcolor: 'white', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    border: '1px solid rgba(0,0,0,0.08)',
                    mb: 3, 
                    position: 'relative',
                    zIndex: 2, 
                    cursor: event.targetId ? 'pointer' : 'default',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: event.targetId ? 'scale(1.1)' : 'none',
                      boxShadow: event.targetId ? '0 5px 15px rgba(0,0,0,0.1)' : 'none'
                    }
                  }}
                >
                  {event.icon}

                  {/* 3. MOBIL VONALDARAB: Az Ikon és a Szöveg között */}
                  <Box 
                    sx={{ 
                      display: { xs: 'block', md: 'none' },
                      position: 'absolute', 
                      bottom: '-24px', 
                      left: '50%', 
                      transform: 'translateX(-50%)',
                      width: '1px', 
                      height: '24px', 
                      bgcolor: 'primary.main', 
                      zIndex: -1 
                    }} 
                  />
                </Box>

                {/* 3. Szövegek */}
                {/* === VÁLTOZÁS ITT: minHeight átállítva { xs: 'auto', md: '60px' }-re === */}
                <Box sx={{ textAlign: 'center', minHeight: { xs: 'auto', md: '60px' }, position: 'relative', zIndex: 2, px: 1 }}>
                  <Typography 
                    variant="h5" 
                    sx={{ color: '#333', fontWeight: 700, lineHeight: 1.2 }}
                  >
                    {event.title}
                  </Typography>
                  {event.sub && (
                    <Typography 
                      onClick={() => scrollToLocation(event.targetId)}
                      variant="body2" 
                      sx={{ 
                        color: '#ceb004', 
                        mt: 1,
                        fontWeight: 700,
                        fontSize: '1.1rem',
                        cursor: event.targetId ? 'pointer' : 'default',
                        display: 'inline-block',
                        transition: 'color 0.3s',
                        '&:hover': {
                          color: event.targetId ? 'primary.main' : 'text.secondary',
                          textDecoration: event.targetId ? 'underline' : 'none'
                        }
                      }}
                    >
                      {event.sub}
                    </Typography>
                  )}
                </Box>

                {/* --- 4. MOBIL VONALDARAB: A szöveg végétől a következő elem kapszulájáig --- */}
                {i !== events.length - 1 && (
                  <Box 
                    sx={{ 
                      display: { xs: 'block', md: 'none' },
                      position: 'absolute', 
                      bottom: '-48px', 
                      left: '50%', 
                      transform: 'translateX(-50%)',
                      width: '1px', 
                      height: '48px', 
                      bgcolor: 'primary.main', 
                      zIndex: 0 
                    }} 
                  />
                )}
                {/* --------------------------------------------------------------------- */}

              </motion.div>
            ))}
          </Box>
        </Box>

      </Container>
    </Box>
  );
};

export default Program;